(function ($) {
  'use strict';

  let environment = {
    app_version: '',
    base_url: 'http://app.acessorh.localhost',
    benefits_url: 'http://form-benefits.acessorh.localhost',
    cdn_url: 'http://cdn1.acessorh.localhost',
    conta_unico_client_id: 'people',
    conta_unico_url: 'http://localhost:8080/realms/custom/protocol/openid-connect/auth',
    current_environment: '',
    grpc_url: '',
    identity_url: 'http://identity.acesso.localhost',
    iframe_resizer_key: '',
    launchDarklyClientId: '63ea5db5e87179139977b661',
    maps_key: '',
    mixpanelToken: 'f4069d9b550ea08e34089810c2abd5be',
    preview: 'false',
    productId: '',
    production: false,
    redirect_uri: 'http://app.acessorh.localhost/callback',
    report_versions: '',
    segmentApiKey: 'aJSx6ITwDTBcFEq6je022Y0UrC52Khm1',
    sentry_dsn: 'https://dfe4667da7ae47369e201af9755f3c6e@o939397.ingest.sentry.io/4505229455720448',
    sentry_enabled: false,
    sentry_ignore_errors: '',
    sentry_ignore_status_code_errors: '',
    sign_callback_url: '',
    sign_envelopes_management_url: '',
    sign_id: 'DB8EF2DD966F2CE9F3237F1A1746143B346393D373C7268FFC32759DE06597EA',
    sign_people_product_id: '',
    sign_url: '',
    snippet_zendesk: 'https://static.zdassets.com/ekr/snippet.js?key=e5d2743c-b85c-4085-9c9a-7ad36458393a',
    url: 'http://svc1.acessorh.localhost',
    url_benefit: '',
    url_grpc: '',
    url_routing_api: 'https://admin.acessorh.com.br/api/routing/v1'
  };

  if (typeof define === 'function' && define.amd) {
    define(function () {
      return environment;
    });
  } else if (typeof module === 'object' && module.exports) {
    module.exports = environment;
  } else {
    $.environment = environment;
  }
})(window);
